export default "/images/almbrand.png?21370bcea3f0c744d849671fe23d8555";